import { render } from "./Carrello.vue?vue&type=template&id=26a1395b"
import script from "./Carrello.vue?vue&type=script&lang=js"
export * from "./Carrello.vue?vue&type=script&lang=js"
script.render = render

export default script